<template>
  <div v-loading="loading">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0" class="ruleForm">
      <div class="tips">问题/意见描述</div>
      <el-form-item prop="input1">
        <el-input v-model="ruleForm.input1" class="input1" placeholder="请输入10字以上的问题描述，以便我们更好的帮你解决问题" type="textarea"
                  :rows="8"></el-input>
      </el-form-item>
      <div class="tips">上传问题截图，最多4张</div>
      <el-form-item prop="upLoadImg">
        <el-upload class="avatar-uploader" action="#" :limit="4" ref="upload1" :auto-upload="false"
                   accept=".png,.gif,.jpeg,.jpg" list-type="picture-card" :file-list="fileList1"
                   :before-upload="beforeUpload1">
          <img v-if="ruleForm.upLoadImg" :src="ruleForm.upLoadImg" class="avatar" width="146px" height="146px">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <div class="tips">联系方式（选填）</div>
      <el-form-item prop="input2">
        <el-input v-model="ruleForm.input2" class="input2" placeholder="请输入手机号码或邮箱，便于我们与你联系"></el-input>
      </el-form-item>
    </el-form>
    <div class="red_button" @click="submit">提交</div>
  </div>
</template>
<script>
// 网络请求
export default {
  name: "Opinions",
  data() {
    // 最小长度为10
    let validatorCase = function (rule, value, callback) {
      if (value === '') {
        callback(new Error('问题描述不能为空'))
      } else if (value.length < 10) {
        callback(new Error('请输入10字以上的问题描述，以便我们更好的帮你解决问题'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      ruleForm: {input1: '', input2: '', upLoadImg: ''},
      rules: {
        input1: [{validator: validatorCase, trigger: 'blur'}]
      },
      fileList1: [],
      imgs: []
    }
  },
  methods: {
    // 图片上传尺寸大小检验
    beforeUpload1(file) {
      let _this = this
      const is1M = file.size / 1024 / 1024 < 1; // 限制小于1M
      const isSize = new Promise(function (resolve, reject) {
        let width = 800; // 限制图片尺寸为800X800
        let height = 800;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function () {
          let valid = img.width > width && img.height > height;
          resolve()
        }
        img.src = _URL.createObjectURL(file);
      }).then(() => {
        // 手动上传图片
        let fd = new FormData();
        fd.append('file', file);//传文件
        this.uploadImgToWangSuMethod(fd)
        return file;
      }, () => {
        _this.$message.error('图片尺寸限制为800 x 800以上，大小不可超过1MB')
        return Promise.reject();
      });
      return false
    },
    // 网络请求 上传图片转化为链接
    uploadImgToWangSuMethod(file) {
      /*uploadImgToWangSu(file).then((res) => {
       if(res.data.code == 200) {
         this.imgs.push(res.data.content.imgPath)
       }else {
         this.loading = false
       }
     })*/
    },
    // 点击提交表单
    submit() {
      if (this.ruleForm.input1.length >= 10) {
        this.$refs.upload1.submit()
      }
      setTimeout(() => {
        this.$refs.ruleForm.validate((val) => {
          if (val) {
            this.saveFeedBackMethod()
          } else {
            this.loading = false
            return false
          }
        })
      }, 1000)
    },
    // 网络请求 添加意见反馈
    saveFeedBackMethod() {
      let cid = JSON.parse(sessionStorage.getItem('cid'))
      let obj = {
        cid: cid ? cid.cid : '',
        contact_way: this.ruleForm.input2,
        content: this.ruleForm.input1,
        img: this.imgs.join(','),
      }
      /*saveFeedBack(obj).then((res) => {
        if(res.data.code == 200) {
          this.$message.success('提交成功!')
          this.$refs.ruleForm.resetFields()
          this.$emit('turnOffDialog')
        }else {
          this.$message.error('提交失败!')
        }
        this.loading = false
      })*/
    }
  },
}
</script>

<style lang="scss" scoped>
.tips {
  font-size: 16px;
  ;
  font-weight: 100;
  color: #333333;
  margin: 10px 0;
}

.little_title {
  margin-bottom: 40px;
}

.input1 {
  width: 478px;
}

.input2 {
  width: 348px;
}

.red_button {
  margin-top: 30px;
  margin-bottom: 50px;
}
</style>